import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserAuthenticationRoutingModule } from './user-authentication-routing.module';
import { LoginComponent } from './login/login.component';
import { ExternalLibrariesModule } from '../external-libraries/external-libraries.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';


@NgModule({
  declarations: [
    LoginComponent
  ],
  imports: [
    CommonModule,
    UserAuthenticationRoutingModule,
    ExternalLibrariesModule,
    ReactiveFormsModule,
    SharedModule
  ]
})
export class UserAuthenticationModule { }
